module.exports = __webpack_public_path__ + "static/media/16684140167137.5a973de8.png";